import { GridFilterModel } from '@mui/x-data-grid/models';

export const makeQuickFilterItem = (name: string, value: unknown) => ({ name, value });

export const findInQuickFilter = <R, >(quickFilterValues: GridFilterModel['quickFilterValues'], name: string): R => {
  return quickFilterValues?.find((item) =>
    item instanceof Object
    && Object.prototype.hasOwnProperty.call(item, 'name')
    && Object.prototype.hasOwnProperty.call(item, 'value')
    && item['name'] === name,
  )?.value;
};
